export const BASE_URL = 'https://elearn-7z5y.onrender.com/'

export const details = 'https://elearn-7z5y.onrender.com'